import APIController from './APIController';
const Subscribe = () =>{
    //Requesthelper
    const {jsonRequest, getWorkspaceId, basicRequest} = APIController()

    const subscribeToPlan = async (planDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/subscription/create`, "POST", planDTO);
        return data;
    }

    const finaliseSubscription = async (sessionId, planId) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/subscription/finalize/${sessionId}/${planId}`, "GET");
        return data;
    };

    const cancelSubscription = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/subscription/cancel`, "POST");
        return data;
    }

    const createPlan = async (dto) => {
        const data = await basicRequest(`/subscriptions/admin/plans`, "POST", dto);
        return data;
    }

    const updatePlan = async (id, dto) => {
        const data = await basicRequest(`/subscriptions/admin/plans/${id}`, "PUT", dto);
        return data;
    }

    const getPlans = async () => {
        const data = await jsonRequest(`/subscriptions`);
        return data;
    }

    const getAllPlans = async () => {
        const data = await jsonRequest(`/subscriptions/admin`);
        return data;
    }

    return {
        subscribeToPlan,
        finaliseSubscription,
        cancelSubscription,
        getPlans,
        updatePlan,
        createPlan,
        getAllPlans
    };
}

export default Subscribe